<template>
  <div>
    <v-app-bar app dense>
      <!--      Mode-->
      <v-btn-toggle dense group v-model="tabNumber" mandatory class="tabs">
        <v-btn
          @contextmenu.stop.prevent="openRenameTab(tab)"
          small
          text
          v-for="tab in tabs"
          :key="tab['.key']"
        >
          {{ tab.name }}
        </v-btn>
      </v-btn-toggle>
      <v-spacer />
      <v-img
        class="d-none d-md-block"
        src="../../public/img/icons/android-chrome-192x192.png"
        height="70px"
        width="70px"
        contain
      ></v-img>
      <v-spacer />
      <!-- share dialog -->
      <v-dialog width="300" scrollable>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon aria-label="share">
            <v-icon>{{ platformIcon }}</v-icon>
          </v-btn>
        </template>
        <v-card v-if="screenType !== 'xs'">
          <p class="text-center text-h5 mt-5 ">{{ $t('share_app_mobile') }}</p>

          <a
            class="text-center mb-5"
            href="https://play.google.com/store/apps/details?id=com.translato.app&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
            ><img
              alt="Get it on Google Play"
              src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
              width="200px"
          /></a>
        </v-card>

        <v-card height="250px" v-else>
          <v-card-text>
            <p class="text-center text-h5 mt-5 ">{{ $t('share_translato') }}</p>
            <v-row no-gutters>
              <v-col class="text-center"
                ><v-btn icon @click="share('share')"
                  ><v-icon>mdi-desktop-mac</v-icon></v-btn
                ></v-col
              >
              <v-col class="text-center"
                ><v-btn icon @click="share('desktop')"
                  ><v-icon>mdi-web</v-icon></v-btn
                ></v-col
              >
            </v-row>
            <v-row no-gutters>
              <v-col class="text-center">{{ $t('share_app') }}</v-col>
              <v-col class="text-center">{{ $t('use_on_pc') }}</v-col>
            </v-row>
            <p class="text-center mt-5">
              <a @click="share('desktop')">{{ translatoLink }}</a>
            </p>
            <!-- <v-col><v-btn><v-icon>mdi-share-variant</v-icon></v-btn></v-col> -->
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- tiptap help box -->
      <v-dialog width="500" scrollable>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="screenType !== 'xs'"
            v-bind="attrs"
            v-on="on"
            icon
            aria-label="help"
          >
            <v-icon>mdi-information-variant</v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-card-text style="height: 500px;">
            <tip-help></tip-help>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!--      <a>{{this.user.displayName}}</a>-->
      <v-menu transition="slide-y-transition" offset-y bottom open-on-hover>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-avatar size="40px" color="primary white--text">
              <img
                v-if="user && user.photoURL"
                :src="user && user.photoURL"
                alt="User"
              />
              <h2 v-else>G</h2>
            </v-avatar>
          </v-btn>
        </template>
        <v-list>
          <v-list-item to="/settings">
            <v-list-item-title
              ><span><v-icon>mdi-cog</v-icon></span
              >&nbsp;{{ $t('settings') }}</v-list-item-title
            >
          </v-list-item>
          <v-list-item
            v-if="this.user && this.user.isAnonymous"
            @click="linkAuth"
          >
            <v-list-item-title>
              <span><v-icon>mdi-account-circle</v-icon></span
              >&nbsp;{{ $t('login') }}</v-list-item-title
            >
          </v-list-item>
          <v-list-item v-else @click="logout">
            <v-list-item-title
              ><span><v-icon>mdi-logout</v-icon></span
              >&nbsp;{{ $t('logout') }}</v-list-item-title
            >
          </v-list-item>
          <v-list-item href="mailto:vik17ag@gmail.com">
            <v-list-item-title
              ><span><v-icon>mdi-help</v-icon></span
              >&nbsp;{{ $t('help') }}</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </v-menu>

      <!-- <v-btn icon>
        <v-icon v-if="this.user.isAnonymous"  @click="linkAuth">mdi-account-circle</v-icon>
        <v-icon v-else  @click="logout">mdi-logout</v-icon>

      </v-btn> -->

      <!--      Tab rename dialog-->
      <v-dialog v-model="renameTabVModel">
        <v-card>
          <v-card-title>{{ $t('rename_tab') }}</v-card-title>
          <v-card-subtitle>
            <v-text-field
              outlined
              @keyup.enter="renameTab"
              clearable
              :placeholder="$t('tab_name')"
              filled
              v-model="renameTabText"
            />
          </v-card-subtitle>
        </v-card>
      </v-dialog>

      <!--      delete dialog-->
      <v-dialog v-model="openDeleteTemplateDialog">
        <v-card>
          <v-card-title>
            <a>{{ $t('delete_template') }}</a>
          </v-card-title>
          <v-card-actions>
            <v-btn text @click.stop="deleteTemplateMethod(true)">{{
              $t('delete')
            }}</v-btn>
            <v-btn text @click.stop="deleteTemplateMethod(false)"
              >{{ $t('cancel') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!--      Save template-->
      <v-dialog v-model="openAddTemplateDialog">
        <v-card>
          <v-card-title>
            {{ currentTemplateId ? $t('save_template') : $t('new_template') }}
            <v-spacer />
            <v-btn color="black" icon @click="openAddTemplateDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <a>{{ $t('subject') }} : </a>
            <v-text-field
              autofocus
              outlined
              :placeholder="$t('subject')"
              filled
              v-model="newTemplateTitle"
              :error-messages="errorMessage"
            >
            </v-text-field>
            <tiptap v-model="quillText" :hideSave="true" />
          </v-card-text>

          <v-card-actions v-if="currentTemplateId">
            <v-container class="pt-0 mt-0">
              <v-row no-gutters>
                <v-col align-self="center">
                  <v-btn
                    color="primary white--text"
                    @click="addAsTemplate(true)"
                    >{{ $t('save') }}</v-btn
                  >
                </v-col>
                <v-col align-self="center">
                  <v-btn
                    color="red white--text"
                    @click="deleteTemp(currentTemplateId)"
                    >{{ $t('delete') }}</v-btn
                  >
                </v-col>
                <!--                <v-col align-self="center">
                  <v-select
                    :items="templates"
                    item-text="subject"
                    item-value=".key"
                    v-model="saveTemplateVModel"
                  ></v-select>
                </v-col>-->
              </v-row>
            </v-container>
          </v-card-actions>
          <v-card-actions v-else>
            <v-btn
              color="primary white--text"
              slot="append"
              @click="addAsTemplate(false)"
              align-self="center"
              >{{ $t('create_new') }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-app-bar>

    <!-- Sizes your content based upon application components -->
    <v-main class="pa-0">
      <!-- Provides the application the proper gutter -->
      <v-container fluid>
        <!--        Search bar-->
        <v-text-field
          v-if="search"
          v-model="searchText"
          dense
          clearable
          autofocus
          :label="$t('search_templates')"
          outlined
          @keydown.esc="searchClick(false)"
        ></v-text-field>

        <!--      Templates-->
        <div style="display: flex;align-items: center;justify-content: center;">
          <div class="chipGroup">
            <v-chip
              @click="
                translate(
                  itemT['.key'],
                  itemT.template,
                  itemT.subject,
                  currentLanguage,
                  true
                ),
                  (templateSelection = index)
              "
              class="mb-1 ml-1"
              :close="templateEdit"
              close-icon="mdi-delete"
              v-for="(itemT, index) in templates"
              active-class="primary--text"
              :key="itemT['.key']"
              @click:close="deleteTemp(itemT['.key'])"
              @contextmenu.stop.prevent="reponseOptions($event, itemT)"
              :style="{
                color: templateSelection === index ? '#1976d2' : 'black'
              }"
              :class="[
                itemT.isPublic ? 'blue' : 'lime',
                'lighten-3',
                'font-weight-medium'
              ]"
            >
              {{ itemT.subject }}
            </v-chip>
          </div>
        </div>
        <div
          style="display: flex;align-items:center;justify-content: space-between; margin-top: 1rem;"
        >
          <v-chip @click="saveTemplate(null)" class="mx-1">+</v-chip>
          <!--        edit button-->
          <v-btn
            color="primary white--text"
            v-if="search"
            @click="searchClick(!search)"
            x-small
            fab
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn
            color=" translucent"
            v-else
            @click="searchClick(!search)"
            x-small
            fab
            aria-label="search"
          >
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </div>
        <!-- template menu -->
        <v-menu
          v-model="showResponseMenu"
          :position-x="responseMenu.x"
          :position-y="responseMenu.y"
        >
          <v-list>
            <v-list-item @click="makeTemplatePublic">
              {{ templateState }}
            </v-list-item>
            <v-list-item @click="saveTemplate(selectedItem)">
              Edit
            </v-list-item>
            <v-list-item @click="deleteTemp(selectedItem['.key'])">
              Delete
            </v-list-item>
          </v-list>
        </v-menu>

        <!--      Copy Subject-->
        <!-- <div class="mb-3 mt-1" v-if="tabNumber > 0" style="text-align: center">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                rounded
                small
                @click="copyFormatted(targetSubject, true)"
              >
                <v-icon left>
                  mdi-content-copy
                </v-icon>
                {{ targetSubject }}
              </v-btn>
            </template>
            <span>{{ $t("copy_subject") }}</span>
          </v-tooltip>
        </div> -->
        <v-checkbox
          v-model="includeSalutationAndSignature"
          color="primary"
          hide-details
          :label="$t('include_sal_sig')"
        >
        </v-checkbox>
        <v-tabs
          v-if="includeSalutationAndSignature"
          v-model="salIndex"
          background-color="transparent"
          color="basil"
        >
          <v-tab v-for="item in salArray" :key="item.index">
            {{ item.name }}
          </v-tab>
        </v-tabs>
        <v-expansion-panels
          style="width:400px"
          class="ml-1"
          flat
          v-if="salutationArray.length > 1"
        >
          <v-expansion-panel @change="salutationPanel" class="px-2">
            <v-expansion-panel-header class="ma-0 pa-0 ">
              <template v-slot:actions>
                <v-icon class="px-4">
                  $expand
                </v-icon>
              </template>

              <span class="py-5"
                >{{ $t('salutation') }} -
                {{ salutationArray[salIndex].name }}</span
              >
            </v-expansion-panel-header>
          </v-expansion-panel>
        </v-expansion-panels>

        <!--      Salutation-->

        <tiptap
          v-show="showSalutation"
          v-if="salutationArray.length > 1"
          @save="updateSalutation(quillTextSalutation)"
          @clear="quillTextSalutation = ''"
          v-model="quillTextSalutation"
        />

        <!--      Main body-->
        <tiptap
          @save="saveTemplate(false)"
          v-model="quillText"
          @clear="quillText = ''"
          clear
          :hideSave="true"
          :showMenu="true"
          @menu="menuItemClicked"
        />
        <v-expansion-panels style="width:400px" class="ml-1" flat>
          <v-expansion-panel @change="signaturePanel" class="px-2">
            <v-expansion-panel-header class="ma-0 pa-0">
              <template v-slot:actions>
                <v-icon class="px-4">
                  $expand
                </v-icon>
              </template>

              <span class="py-5"
                >{{ $t('signature') }}
                <span v-if="salutationArray.length > 1"
                  >- {{ salutationArray[salIndex].name }}</span
                ></span
              >
            </v-expansion-panel-header>
          </v-expansion-panel>
        </v-expansion-panels>
        <!--        signature-->
        <tiptap
          v-show="showSignature"
          @save="updateSignature(quillTextSignature)"
          v-model="quillTextSignature"
          @clear="quillTextSignature = ''"
        />

        <!--        Fabs for languages-->

        <v-row justify="center" class="fab-container ma-3 langfab">
          <v-col cols="auto">
            <v-btn
              fab
              small
              aria-label="copy and translate"
              color="orange"
              class="mr-1"
              @click="
                setLanguageAndTranslate(
                  quillText,
                  targetSubject,
                  currentLanguage
                )
              "
            >
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
            <v-btn
              v-for="(item, index) in languages.slice(0, 5)"
              :key="index"
              class="mr-1"
              @click="setLanguageAndTranslate(quillText, targetSubject, item)"
              small
              color=" translucentFab  white--text"
              fab
            >
              {{ item }}
            </v-btn>
            <v-speed-dial
              :open-on-hover="screen !== 'xs'"
              direction="top"
              class="d-inline"
            >
              <template v-slot:activator>
                <v-btn
                  v-model="fab"
                  color="primary white--text"
                  dark
                  fab
                  small
                  aria-label="languages"
                >
                  <v-icon small>
                    mdi-translate
                  </v-icon>
                </v-btn>
              </template>
              <v-btn
                v-for="(item, index) in languages.slice(5, languages.length)"
                :key="index"
                fab
                small
                color="primary white--text"
                class="mr-1"
                @click="setLanguageAndTranslate(quillText, targetSubject, item)"
                >{{ item }}
              </v-btn>

              <v-btn
                fab
                dark
                small
                color="primary white--text"
                @click="addLanguage"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-speed-dial>
            <v-btn
              @click="copyOnlyEnglish"
              small
              fab
              class="blue white--text ml-1"
              >EN</v-btn
            >
          </v-col>
        </v-row>
        <!--      Progress bar-->
        <!-- <v-row>
          <div v-if="loading" class="fab-container  mb-16">
            <v-chip style="min-width: 400px" color="orange"
              ><h2>{{ $t('translating') }}</h2></v-chip
            >
          </div>
        </v-row> -->

        <v-btn
          style=" position: fixed; bottom: 50px; right: 5px;"
          x-small
          fab
          aria-label="scroll-down"
          @click="scroll($refs.output)"
          class="langfab translucent"
        >
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>

        <h2>
          {{ $t('copied_preview') }}
        </h2>
        <div
          :class="{ 'ma-1': true, 'pa-2': target }"
          v-html="target"
          ref="output"
          style="text-align: start; font-family: sans-serif; background-color: #1A73E8 ; color:white;min-height:4rem;"
        />
      </v-container>
    </v-main>

    <v-footer app>
      <!-- -->
    </v-footer>
    <v-dialog
      max-width="400"
      v-model="langDialog"
      @click:outside="langDialog = langAlert = false"
      scrollable
    >
      <v-card v-if="langDialog">
        <v-card-title>{{ $t('choose_language') }}</v-card-title>
        <v-alert
          dense
          class="mx-5"
          border="right"
          colored-border
          type="error"
          :value="langAlert"
        >
          {{ $t('language_exists') }}
        </v-alert>
        <v-card-text style="height:400px">
          <SelectComponent
            :items="languageList"
            @select="selectLanguage"
          ></SelectComponent>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      width="300"
      v-model="templateLimitExceed"
      scrollable
      @click:outside="templateLimitExceed = false"
    >
      <v-card height="250" v-if="!premium">
        <p class="text-center text-h5 mt-5 ">{{ $t('upgrade_premium') }}</p>
        <v-card-text class="text-center">{{ $t('premium_text') }} </v-card-text>
        <v-layout justify-center
          ><v-btn
            color="grey darken-3 white--text"
            tile
            @click="getPremium()"
            class="my-3"
          >
            <v-icon color="#FFD700">mdi-crown</v-icon
            >{{ $t('get_premium') }}</v-btn
          ></v-layout
        >
      </v-card>
      <v-card v-else>
        <p class="text-center text-h5 mt-5 ">{{ $t('premium_user') }}</p>
        <v-card-text class="text-center"
          >{{ $t('premium_user_text') }}
        </v-card-text>
        <v-layout justify-center
          ><v-btn color="grey darken-3 white--text" tile class="my-3">
            <v-icon color="#FFD700">mdi-crown</v-icon>{{ $t('premium') }}</v-btn
          ></v-layout
        >
      </v-card>
    </v-dialog>

    <v-snackbar app v-model="offline" color="red" timeout="1000">
      {{ $t('offline_text') }}
    </v-snackbar>
    <v-dialog width="300" v-model="storeRatingDialog">
      <v-card height="auto">
        <v-card-title class="text-h5">
          {{ $t('rate_app_store') }}
        </v-card-title>
        <v-card-text>
          {{ $t('rating_text_2') }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-space-between">
          <v-btn text @click="storeRatingDialog = false">
            {{ $t('later') }}
          </v-btn>
          <v-btn
            color="primary"
            text
            href="https://play.google.com/store/apps/details?id=com.translato.app"
          >
            {{ $t('rate_now') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      :style="{ position: 'fixed', top: '50px' }"
      v-model="snackbar"
      timeout="500"
      rounded="pill"
      top
      absolute
      content-class="copied"
      >{{ snackbarText }}</v-snackbar
    >
    <app-review
      v-if="enableReview"
      :user="user"
      @store="storeRatingDialog = true"
    ></app-review>
    <make-public-page
      :user="user"
      v-if="isPublic"
      :publicPage="publicPage"
      @close="isPublic = false"
    ></make-public-page>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import { AdMob, InterstitialAdPluginEvents } from '@capacitor-community/admob'
import axios from 'axios'
import Tiptap from '@/components/Tiptap'
import { auth, db } from '../../firebaseconfig'
import { cfaSignOut } from 'capacitor-firebase-auth'
import tipHelp from '../components/help.vue'
import { platform } from '../plugins/capacitorPlugin.js'
import { Share } from '../plugins/capacitorPlugin.js'
import { Browser } from '@capacitor/browser'
import appReview from '../components/appReview.vue'
import makePublicPage from '../components/makePublicPage.vue'
import SelectComponent from '../components/SelectComponent.vue'
export default {
  name: 'Home',
  components: {
    makePublicPage,
    Tiptap,
    appReview,
    tipHelp,
    SelectComponent
  },
  data() {
    return {
      lastTranslatedText: '',
      salutationTab: null,
      includeSalutationAndSignature: true,
      snackbar: false,
      snackbarText: '',
      tempKey: '',
      publicPageDetails: '',
      isPublic: false,
      showResponseMenu: false,
      responseMenu: {
        x: 0,
        y: 0
      },
      selectedItem: '',
      storeRatingDialog: false,
      offline: false,
      templateLimitExceed: false,
      showSalutation: false,
      showSignature: false,
      screen: '',
      fab: false,
      langAlert: false,
      selectedLanguage: '',
      langDialog: false,
      languageList: [],

      searchText: '',
      search: false,
      templateSelection: 0,
      allTabs: [],
      allTemplates: [],
      saveTemplateVModel: '',
      currentTemplateId: '',
      currentTab: {
        index: 1,
        name: ''
      },
      renameTabText: '',
      renameTabVModel: false,
      openDeleteTemplateDialog: false,
      openAddTemplateDialog: false,
      templateEdit: false,
      tabNumber: 0,
      config: {
        theme: 'snow',
        modules: {
          toolbar: false
        }
      },
      quillText: '',
      quillTextSalutation: '',
      quillTextSignature: '',
      loading: false,
      newTemplateTitle: '',
      target: '',
      errorMessage: '',
      targetSubject: '',
      salutationArray: [],
      signatureArray: [],
      salIndex: 0,
      feedback: '',
      enableReview: false,
      translatedText: ''
    }
  },
  computed: {
    templateState() {
      if (this.selectedItem.isPublic) return 'Make Private'
      else return 'Make Public'
    },
    platformIcon() {
      if (this.screenType === 'xs') return 'mdi-desktop-mac'
      else return 'mdi-cellphone'
    },
    translatoLink() {
      return 'https://html-translator.web.app/'
    },
    tabName() {
      if (this.tabs[this.salIndex]) return this.tabs[this.salIndex].name
      return ''
    },

    screenType() {
      return this.$vuetify.breakpoint.name
    },
    templates() {
      if (this.searchText) {
        return this.templatesLocal.filter((t) => {
          return (
            t.tab === this.tabNumber &&
            t.subject &&
            t.subject
              .toLocaleLowerCase()
              .includes(this.searchText.toLocaleLowerCase())
          )
        })
      } else {
        return this.templatesLocal.filter((t) => {
          return t.tab === this.tabNumber
        })
      }
    },
    tabs() {
      return this.tabsLocal
    },
    ...mapState({
      user: (state) => state.user,
      templatesLocal: (state) => state.templatesLocal,
      tabsLocal: (state) => state.tabsLocal,
      languages: (state) => state.primaryLanguages
    }),
    ...mapGetters({
      currentLanguage: 'getCurrentLang',
      dictionary: 'getDictionary',
      primaryLanguages: 'getPrimaryLanguages',
      salArray: 'getSalutationArray',
      sigArray: 'getSignatureArray',
      premium: 'getPremium',
      showOriginal: 'getOriginalText',
      onlineStatus: 'getOnlineStatus',
      publicPage: 'getPublicPage',
      publicPageUrl: 'getPublicPageUrl'
    }),
    ...mapActions({
      checkUserStatus: 'checkUserStatus'
    })
  },
  watch: {
    publicPageDetails(val) {
      if (val) this.$store.commit('setPublicPage', val.value)
    },
    feedback(val) {
      if (val) {
        if (val.rating > 0) {
          this.enableReview = false
        } else {
          setTimeout(() => {
            this.enableReview = true
          }, 10000)
        }
      }
    },
    salIndex(val) {
      this.salIndex = val
      this.quillTextSalutation = this.salutationArray[val].text
      this.quillTextSignature = this.signatureArray[val].text
    },

    // tabNumber(v) {
    //   // this.quillTextSalutation = ''
    //   // this.quillTextSignature = ''
    //   // this.salArray.forEach(e => {

    //   //   if(e.index===v){e
    //   //     this.quillTextSalutation = e.text
    //   //   }
    //   // });
    //   //   this.sigArray.forEach(e => {
    //   //   if(e.index===v){
    //   //     this.quillTextSignature  = e.text
    //   //   }
    //   // });
    // },
    allTabs(v) {
      if (v) {
        this.$store.commit('setTabs', v)
      }
    },
    allTemplates(v) {
      if (v) this.$store.commit('setTemplates', v)
    },
    salutationArray(v) {
      if (v.length > 0) {
        this.$store.commit('setSalutationArray', v)
      }
    },
    signatureArray(v) {
      if (v.length > 0) {
        this.$store.commit('setSignatureArray', v)
      }
    }
  },

  async mounted() {
    window.addEventListener('keydown', (e) => {
      if (e.ctrlKey && e.key === 'f') {
        e.preventDefault()
        this.search = true
      }
    })
    this.quillTextSalutation = this.salArray[0] ? this.salArray[0].text : ''
    this.quillTextSignature = this.sigArray[0] ? this.sigArray[0].text : ''
    if (this.user) {
      db.ref('users')
        .child(this.user.uid)
        .child('languages')
        .once('value')
        .then((snapshot) => {
          const value = snapshot.val()
          if (value) {
            this.$store.commit('setPrimaryLanguages', value)
          }
        })
      await db
        .ref('users')
        .child(this.user.uid)
        .child('isPublic')
        .once('value')
        .then((data) => {
          if (data.exists()) {
            const val = data.val()
            const subDomain = val.subDomain
            const url = `https://html-translator.firebaseapp.com/public/${subDomain}`
            this.setPublicPageUrl(url)
          }
        })
    }

    await this.checkUserStatus

    let ref = db.ref('users').child(this.user.uid)

    //Reactive since array
    this.$rtdbBind('allTemplates', ref.child('templates')).then()
    this.$rtdbBind('allTabs', ref.child('tabs')).then()
    this.$rtdbBind('feedback', ref.child('feedback')).then()
    this.$rtdbBind('publicPageDetails', ref.child('isPublic')).then()

    // //Need to wait for string changing for starter templates
    await this.$rtdbBind('salutationArray', ref.child('salutationArray'))
    await this.$rtdbBind('signatureArray', ref.child('signatureArray'))
    this.quillTextSalutation = this.salutationArray[this.tabNumber]
      ? this.salutationArray[this.tabNumber].text
      : ''
    this.quillTextSignature = this.signatureArray[this.tabNumber]
      ? this.signatureArray[this.tabNumber].text
      : ''
    //initialize with local storage
    if (!this.quillTextSalutation) this.quillTextSalutation = ''
    if (!this.quillTextSignature) this.quillTextSignature = ''
  },
  methods: {
    copyOnlyEnglish() {
      let salutation = ''
      let signature = ''
      if (this.includeSalutationAndSignature && this.salutationArray.length > 0)
        salutation = this.salutationArray[this.salIndex].text
      if (this.includeSalutationAndSignature && this.signatureArray.length > 0)
        signature = this.signatureArray[this.salIndex].text
      let body = salutation + this.quillText + signature
      this.copyFormatted(body, true)
    },
    selectLanguage(e) {
      this.langDialog = false
      const value = e.value
      if (value) {
        this.searchLanguage(value)
      }
    },
    copyText() {
      navigator.clipboard.writeText(this.translatedText)
      this.snackbar = true
      this.snackbarText = this.$t('copied')
    },
    convertToText(html) {
      console.log(html)
      const text = html.innerText
      return text
    },
    ...mapActions(['getPremium']),
    ...mapMutations({
      setPublicPageUrl: 'setPublicPageUrl'
    }),
    async makeTemplatePublic() {
      if (this.publicPage) {
        let status
        if (this.selectedItem) {
          if (this.selectedItem.isPublic) status = false
          else status = true
          db.ref()
            .child('users')
            .child(this.user.uid)
            .child('templates')
            .child(this.selectedItem['.key'])
            .child('isPublic')
            .set(status)
        }
      } else this.isPublic = true
    },
    reponseOptions(event, item) {
      this.selectedItem = item
      this.showResponseMenu = false
      this.responseMenu.x = event.clientX
      this.responseMenu.y = event.clientY
      this.$nextTick(() => {
        this.showResponseMenu = true
      })
    },
    selectSalutationItem(index) {
      this.salIndex = index
    },
    async share(type) {
      switch (type) {
        case 'desktop':
          await Browser.open({ url: this.translatoLink })
          break
        case 'share':
          await Share.share({
            title: 'Share Translato',
            text: '',
            url: this.translatoLink,
            dialogTitle: 'Share with buddies'
          })
          break
      }
    },
    async showInterstitial() {
      if (!this.premium) {
        AdMob.addListener(InterstitialAdPluginEvents.Loaded, () => {
          // Subscribe prepared interstitial
        })

        const options = {
          adId: process.env.VUE_APP_ADMOB_INTERSTITIAL_KEY,
          isTesting: false,
          npa: true
        }
        await AdMob.prepareInterstitial(options)
        await AdMob.showInterstitial()
      }
    },
    signaturePanel() {
      this.showSignature = !this.showSignature
    },
    salutationPanel() {
      this.showSalutation = !this.showSalutation
    },
    menuItemClicked(item) {
      switch (item) {
        case 'New':
          this.saveTemplate(null)
          break
        case 'Edit':
          if (!this.tempKey) this.saveTemplate(this.templates[0])
          else
            this.templates.forEach((e, i) => {
              if (e['.key'] === this.tempKey)
                this.saveTemplate(this.templates[i])
            })

          break
        case 'Clear':
          this.quillText = ''
          break
      }
    },
    scroll(element) {
      this.$vuetify.goTo(element, { duration: 500 })
    },
    searchLanguage(language) {
      this.selectedLanguage = ''
      if (this.primaryLanguages.length > 4 && !this.premium) {
        this.templateLimitExceed = true
      } else {
        this.langDialog = false
        if (
          this.primaryLanguages.length < 5 &&
          !this.primaryLanguages.includes(language)
        ) {
          this.$store.commit('setPrimaryLanguages', [
            ...this.languages,
            language
          ])
        }
        this.setLanguageAndTranslate(
          this.quillText,
          this.targetSubject,
          language
        )
      }
    },

    addLanguage() {
      this.langDialog = true
      this.languageList = this.$store.getters.getAllLanguages
    },
    searchClick(v) {
      this.search = v
      this.searchText = ''
    },
    openRenameTab(tab) {
      this.renameTabText = tab['name']
      this.renameTabVModel = true
      this.currentTab = tab
    },
    renameTab() {
      db.ref('users')
        .child(this.user.uid)
        .child('tabs')
        .child(this.currentTab['.key'])
        .child('name')
        .set(this.renameTabText)
      this.renameTabVModel = false
    },
    updateSalutation(v) {
      if (this.user.uid) {
        let obj = { index: this.salIndex, text: v ? v : '' }
        db.ref('users')
          .child(this.user.uid)
          .child('salutationArray')
          .child(this.salIndex)
          .update(obj)
      }
    },
    updateSignature(v) {
      if (this.user.uid) {
        let obj = { index: this.salIndex, text: v ? v : '' }
        db.ref('users')
          .child(this.user.uid)
          .child('signatureArray')
          .child(this.salIndex)
          .update(obj)
      }
    },
    deleteTemp(id) {
      this.openDeleteTemplateDialog = true
      this.currentTemplateId = id
    },
    deleteTemplateMethod(isDelete) {
      this.openDeleteTemplateDialog = false
      this.newTemplateTitle = ''

      if (this.currentTemplateId && isDelete) {
        this.tempKey = null
        db.ref('users')
          .child(this.user.uid)
          .child('templates')
          .child(this.currentTemplateId)
          .set(null)
      }
      this.currentTemplateId = null
      this.openAddTemplateDialog = false
      this.$toasted.show(this.$t('template_deleted'))
    },
    saveTemplate(template) {
      this.openAddTemplateDialog = true
      if (!template) {
        this.currentTemplateId = null
        this.newTemplateTitle = ''
        if (this.allTemplates.length > 5 && !this.premium) {
          this.openAddTemplateDialog = false
          this.templateLimitExceed = true
        }
        if (platform === 'android') this.$store.dispatch('logNewTemplateEvent')
      } else {
        this.newTemplateTitle = template.subject
        this.currentTemplateId = this.saveTemplateVModel = template['.key']
      }
    },

    linkAuth() {
      this.$store.commit('setShowUI', true)
      this.$router.push('/login')
    },
    async logout() {
      this.$store.commit('clearVuex')
      await auth.signOut()
      cfaSignOut().subscribe()
    },
    addAsTemplate(isOld) {
      if (this.newTemplateTitle) {
        const templateRef = db
          .ref('users')
          .child(this.user.uid)
          .child('templates')
        let id = this.saveTemplateVModel
        if (!isOld) {
          id = templateRef.push().key
        }
        templateRef.child(id).update({
          tab: this.tabNumber,
          template: this.quillText,
          title: this.newTemplateTitle,
          subject: this.newTemplateTitle
        })
        this.$toasted.show(
          id === this.saveTemplateVModel
            ? this.$t('template_updated')
            : this.$t('new_template_added')
        )

        this.openAddTemplateDialog = false
        this.newTemplateTitle = ''
        this.currentTemplateId = ''
        this.showInterstitial()
      } else {
        this.errorMessage = 'Subject is required'
      }
    },
    setLanguageAndTranslate(quillText, targetSubject, targetLanguage) {
      this.translate(null, quillText, targetSubject, targetLanguage)
    },
    async translate(
      key,
      template,
      targetSubject,
      targetLanguage,
      avoidTranslation
    ) {
      this.tempKey = key
      if (!this.onlineStatus) {
        this.offline = true
      } else {
        this.searchClick()
        let salutation = ''
        let signature = ''
        if (key) this.saveTemplateVModel = key
        if (
          this.includeSalutationAndSignature &&
          this.salutationArray.length > 0
        )
          salutation = this.salutationArray[this.salIndex].text
        if (
          this.includeSalutationAndSignature &&
          this.signatureArray.length > 0
        )
          signature = this.signatureArray[this.salIndex].text
        let body = salutation + template + signature
        if (targetLanguage === this.currentLanguage) {
          if (avoidTranslation) {
            this.lastTranslatedText = body
            this.setResponseView(body, template, targetSubject)
          } else {
            this.setResponseView(
              this.lastTranslatedText,
              template,
              targetSubject
            )
            this.snackbar = true
            this.snackbarText = this.$t('copied')
          }

          this.showInterstitial()
        } else {
          this.loading = true
          let params = {
            'api-version': '3.0',
            to: targetLanguage,
            textType: 'html'
          }

          axios({
            method: 'post',
            url: 'https://api.cognitive.microsofttranslator.com/translate',
            params: params,
            headers: {
              'Ocp-Apim-Subscription-Key':
                process.env.VUE_APP_OCP_APIM_SUBSCRIPTION_KEY,
              'Content-Type': 'application/json',
              charset: 'UTF-8'
            },
            data: [{ Text: body }, { Text: targetSubject }]
          }).then((response) => {
            let enHtml = template
            let html = ''
            if (this.showOriginal)
              html = response.data[0].translations[0].text + body
            else html = response.data[0].translations[0].text
            this.lastTranslatedText = html
            this.setResponseView(
              html,
              enHtml,
              response.data[1].translations[0].text
            )
            this.snackbar = true
            this.snackbarText =
              this.$t('copied_in') + this.dictionary[targetLanguage].name

            this.$store.dispatch('logTranslationEvent')
            this.showInterstitial()
          })
        }
      }
    },
    setResponseView(html, enHtml, targetSubject) {
      this.target = html
      this.quillText = enHtml
      this.targetSubject = targetSubject
      this.loading = false
      this.copyFormatted(html)
    },
    copyFormatted(html, e) {
      // Create container for the HTML
      // [1]
      let container = document.createElement('div')
      container.innerHTML = html

      // Hide element
      // [2]
      container.style.position = 'fixed'
      container.style.pointerEvents = 'none'
      container.style.opacity = 0

      // Detect all style sheets of the page
      var activeSheets = Array.prototype.slice
        .call(document.styleSheets)
        .filter(function(sheet) {
          return !sheet.disabled
        })

      // Mount the container to the DOM to make `contentWindow` available
      // [3]
      document.body.appendChild(container)

      // Copy to clipboard
      // [4]
      window.getSelection().removeAllRanges()

      var range = document.createRange()
      range.selectNode(container)
      window.getSelection().addRange(range)

      // [5.1]
      document.execCommand('copy')

      // [5.2]
      for (var i = 0; i < activeSheets.length; i++)
        activeSheets[i].disabled = true

      // [5.3]
      document.execCommand('copy')
      this.translatedText = this.convertToText(container)

      // [5.4]
      for (var j = 0; j < activeSheets.length; j++)
        activeSheets[j].disabled = false

      // Remove the container
      // [6]
      document.body.removeChild(container)
      if (e) {
        this.$toasted.show(this.$t('subject_copied'))
      }
    }
  },
  created() {
    this.screen = this.$vuetify.breakpoint.name
  }
}
</script>
<style>
*:focus {
  outline: none;
}
.fab-container {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
}
.cd1 .v-input__control {
  width: 0;
  margin-right: 2rem;
}
.langfab {
  z-index: 10;
}
.tabs {
  overflow: scroll;
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.tabs::-webkit-scrollbar {
  display: none;
}
.translucent {
  background-color: rgba(256, 256, 256, 0.5) !important;
}
.translucentFab {
  background-color: rgba(33, 150, 243, 0.8) !important;
}
.copied {
  text-align: center !important;
}

@media (hover: none) {
  .chipGroup {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    height: 120px;
    width: 100vw;
    overflow-x: scroll;
  }
}
</style>
